import { render, staticRenderFns } from "./ondotaiInfo.vue?vue&type=template&id=0e0f0bde&"
import script from "./ondotaiInfo.vue?vue&type=script&lang=js&"
export * from "./ondotaiInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports